module.exports = __webpack_public_path__ + "img/df97633.webp";